export default function NavBar() {
  return (
    <>
      <div className="pb-0 mb-0 text-center">
        <div className="hero-bg">
          <div className="product-holder">
            <img className="logo-bg mt-5 mb-4" src="/white-bg.png" alt="logo" />
            <img className="logo-image" src="/logo.png" alt="logo" />
          </div>
          <h4 className="display-4 fw-bold text-body-emphasis hero-text pb-5">
            EventEase
          </h4>
        </div>
      </div>
    </>
  );
}
